import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CrownSimpleIcon, CheckCircleIcon } from "@phosphor-icons/react";

export default function PlusSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("verifying");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const r = await api.get(`/plus/session/${sessionId}`);
        if (cancelled) return;
        setData(r.data);
        if (r.data.is_plus) {
          setStatus("success");
          return;
        }
        if (tries > 12) {
          setStatus("pending");
          return;
        }
        setTimeout(poll, 1500);
      } catch {
        if (tries > 6) setStatus("error");
        else setTimeout(poll, 1500);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="plus-success-page">
      <Navbar />
      <main className="flex-1 grid place-items-center p-6">
        <div className="max-w-xl w-full text-center">
          {status === "verifying" && (
            <p className="text-zinc-500">Activating your Plus membership…</p>
          )}
          {status === "success" && (
            <>
              <div className="h-20 w-20 mx-auto rounded-full bg-gradient-to-br from-amber-300 to-amber-500 grid place-items-center shadow-xl">
                <CrownSimpleIcon size={48} weight="fill" className="text-white" />
              </div>
              <p className="mt-6 overline text-amber-600">WELCOME TO PLUS</p>
              <h1 className="mt-2 font-display font-black text-5xl tracking-tighter">
                You're in.
              </h1>
              <p className="mt-4 text-zinc-600">
                1% cashback, 2× streaks, early access. Your perks are live starting now.
              </p>
              <div className="mt-8 flex gap-3 justify-center flex-wrap">
                <Link
                  to="/dashboard"
                  className="bg-[#1D78AB] hover:bg-[#0F3C57] text-white px-6 py-3 rounded-full font-bold"
                  data-testid="plus-success-dashboard"
                >
                  Go to Dashboard
                </Link>
                <Link
                  to="/live"
                  className="border border-zinc-300 px-6 py-3 rounded-full font-bold hover:bg-zinc-50"
                  data-testid="plus-success-live"
                >
                  Browse Live
                </Link>
              </div>
            </>
          )}
          {status === "pending" && (
            <>
              <p className="font-display font-black text-3xl">Payment received.</p>
              <p className="text-zinc-600 mt-2">
                Stripe takes a moment to activate your subscription. Refresh in a few seconds — or check /plus.
              </p>
              <Link to="/plus" className="mt-6 inline-block bg-[#1D78AB] text-white px-6 py-3 rounded-full font-bold">
                Check status
              </Link>
            </>
          )}
          {status === "error" && (
            <>
              <p className="font-display font-black text-3xl">Something didn't go through.</p>
              <p className="text-zinc-600 mt-2">
                No charge was made. Try again or contact support@bidorah.com.
              </p>
              <Link to="/plus" className="mt-6 inline-block bg-[#1D78AB] text-white px-6 py-3 rounded-full font-bold">
                Back to Plus
              </Link>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
